export default [
  {
    id: '2-1',
    parentId: '0',
    title: '项目列表',
    path: '/services/project-list',
    type: 2,
    component: '/services/project/project-list/project-list',
    isHidden: false,
    icon: 'kl-project'
  },
  {
    id: '2-2',
    parentId: '0',
    title: '项目详情',
    path: '/services/project-module',
    type: 2,
    component: '/services/project/project-module/project-module',
    isHidden: true,
    icon: 'kl-project'
  },

  {
    id: '2-3',
    parentId: '0',
    title: '项目管理',
    path: '/services/project-manage',
    type: 2,
    component: '/services/project/project-manage/project-manage',
    isHidden: true,
    icon: 'kl-project'
  },

  {
    id: '2-4-1',
    parentId: '0',
    title: ' 提报-编辑',
    path: '/services/project-expert-put-edit',
    type: 2,
    component: '/services/project/all-c-pages/project-expert-put-add-or-edit/project-expert-put-add-or-edit',
    isHidden: true,
    icon: 'kl-project'
  }
]
